import { assetModelTypesSlice } from "./assetModelTypesSlice";
import * as actions from "./assetModelTypesActions";
import * as selectors from "./assetModelTypesSelectors";

export { actions };
export { selectors };
export default assetModelTypesSlice.reducer;
